import * as nearAPI from 'near-api-js';
import { JsonRpcProvider } from 'near-api-js/lib/providers';
import { stringifyJsonOrBytes } from 'near-api-js/lib/transaction';
import { parseRpcError } from 'near-api-js/lib/utils/rpc_errors';
import { signTransactions } from '@near-wallet-selector/wallet-utils';
import { parseAbi, formatUnits, keccak256, toHex, bytesToHex } from 'viem';
import bs58 from 'bs58';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$i =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$b = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$a = fails$b;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$a(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw$1 = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$9 = fails$b;
var classof$7 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$9(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$4 = function (it) {
  return IndexedObject$1(requireObjectCoercible$2(it));
};

var isObject$9 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$8 = isObject$9;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$8(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$8(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$8(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$8(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$a = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$h = global$i;
var isObject$7 = isObject$9;

var document$2 = global$h.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$7(document$2) && isObject$7(document$2.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$2.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$8 = fails$b;
var createElement$1 = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$8(function () {
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$3 = toIndexedObject$4;
var toPrimitive$1 = toPrimitive$2;
var has$9 = has$a;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$9(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$6 = isObject$9;

var anObject$b = function (it) {
  if (!isObject$6(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$5 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$a = anObject$b;
var toPrimitive = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$5 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$a(O);
  P = toPrimitive(P, true);
  anObject$a(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$4 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$7 = DESCRIPTORS$4 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$5 = {exports: {}};

var global$g = global$i;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$7;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$6(global$g, key, value);
  } catch (error) {
    global$g[key] = value;
  } return value;
};

var global$f = global$i;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$f[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$2.inspectSource;

var global$e = global$i;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$e.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$2(WeakMap$1));

var shared$2 = {exports: {}};

var store$1 = sharedStore;

(shared$2.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared$1 = shared$2.exports;
var uid$1 = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$d = global$i;
var isObject$5 = isObject$9;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$7;
var objectHas = has$a;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var WeakMap = global$d.WeakMap;
var set$1, get, has$8;

var enforce = function (it) {
  return has$8(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set$1 = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$8 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$8 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has$8,
  enforce: enforce,
  getterFor: getterFor
};

var global$c = global$i;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$7;
var has$7 = has$a;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$2 = internalState;

var getInternalState$2 = InternalStateModule$2.get;
var enforceInternalState = InternalStateModule$2.enforce;
var TEMPLATE = String(String).split('String');

(redefine$5.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$7(value, 'name')) createNonEnumerableProperty$4(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$c) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$4(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$2(this).source || inspectSource$1(this);
});

var global$b = global$i;

var path$1 = global$b;

var path = path$1;
var global$a = global$i;

var aFunction$5 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$5 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$5(path[namespace]) || aFunction$5(global$a[namespace])
    : path[namespace] && path[namespace][method] || global$a[namespace] && global$a[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$3 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$2 = toInteger$3;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$4 = function (argument) {
  return argument > 0 ? min$1(toInteger$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$1 = toInteger$3;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger$1(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$3 = toLength$4;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$3(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var has$6 = has$a;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$6(hiddenKeys$2, key) && has$6(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$6(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$4 = getBuiltIn$5;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$9 = anObject$b;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$4('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$9(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$5 = has$a;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$5(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$7 = fails$b;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$7(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$9 = global$i;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$7;
var redefine$4 = redefine$5.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$9;
  } else if (STATIC) {
    target = global$9[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$9[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$4(target, key, sourceProperty, options);
  }
};

var classof$6 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray$2 = Array.isArray || function isArray(arg) {
  return classof$6(arg) == 'Array';
};

var aFunction$4 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var aFunction$3 = aFunction$4;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$3(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isArray$1 = isArray$2;
var toLength$2 = toLength$4;
var bind$3 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$3(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        targetIndex = flattenIntoArray$1(target, original, element, toLength$2(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var requireObjectCoercible$1 = requireObjectCoercible$3;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object(requireObjectCoercible$1(argument));
};

var fails$6 = fails$b;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$6(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$8 = global$i;
var shared = shared$2.exports;
var has$4 = has$a;
var uid = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global$8.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol$g = function (name) {
  if (!has$4(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has$4(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var isObject$4 = isObject$9;
var isArray = isArray$2;
var wellKnownSymbol$f = wellKnownSymbol$g;

var SPECIES$3 = wellKnownSymbol$f('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject$4(C)) {
      C = C[SPECIES$3];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var $$6 = _export;
var flattenIntoArray = flattenIntoArray_1;
var toObject$2 = toObject$3;
var toLength$1 = toLength$4;
var toInteger = toInteger$3;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
$$6({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$2(this);
    var sourceLen = toLength$1(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$8 = anObject$b;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = DESCRIPTORS$3 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn$3 = getBuiltIn$5;

var html$2 = getBuiltIn$3('document', 'documentElement');

var anObject$7 = anObject$b;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$e = wellKnownSymbol$g;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$e('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var DESCRIPTORS$2 = descriptors;
var fails$5 = fails$b;
var has$3 = has$a;

var defineProperty$2 = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength$1 = function (METHOD_NAME, options) {
  if (has$3(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has$3(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has$3(options, 0) ? options[0] : thrower;
  var argument1 = has$3(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails$5(function () {
    if (ACCESSORS && !DESCRIPTORS$2) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty$2(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var $$5 = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables$2 = addToUnscopables$3;
var arrayMethodUsesToLength = arrayMethodUsesToLength$1;

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$$5({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('includes');

var iterators = {};

var fails$4 = fails$b;

var correctPrototypeGetter = !fails$4(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$2 = has$a;
var toObject$1 = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject$1(O);
  if (has$2(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var getPrototypeOf$1 = objectGetPrototypeOf;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$7;
var has$1 = has$a;
var wellKnownSymbol$d = wellKnownSymbol$g;

var ITERATOR$5 = wellKnownSymbol$d('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype$2 == undefined) IteratorPrototype$2 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has$1(IteratorPrototype$2, ITERATOR$5)) {
  createNonEnumerableProperty$2(IteratorPrototype$2, ITERATOR$5, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var has = has$a;
var wellKnownSymbol$c = wellKnownSymbol$g;

var TO_STRING_TAG$3 = wellKnownSymbol$c('toStringTag');

var setToStringTag$3 = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$3)) {
    defineProperty$1(it, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isObject$3 = isObject$9;

var aPossiblePrototype$1 = function (it) {
  if (!isObject$3(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

var anObject$6 = anObject$b;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$6(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$4 = _export;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$7;
var redefine$3 = redefine$5.exports;
var wellKnownSymbol$b = wellKnownSymbol$g;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$b('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$4] != 'function') {
          createNonEnumerableProperty$1(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    createNonEnumerableProperty$1(IterablePrototype, ITERATOR$4, defaultIterator);
  }
  Iterators$3[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$3(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$4({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject = toIndexedObject$4;
var addToUnscopables$1 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

addToUnscopables('flat');

var DESCRIPTORS$1 = descriptors;
var fails$3 = fails$b;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$3;
var IndexedObject = indexedObject;

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails$3(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $$3 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$$3({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var global$7 = global$i;

var nativePromiseConstructor = global$7.Promise;

var redefine$2 = redefine$5.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$2(target, key, src[key], options);
  return target;
};

var getBuiltIn$2 = getBuiltIn$5;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$a = wellKnownSymbol$g;
var DESCRIPTORS = descriptors;

var SPECIES$2 = wellKnownSymbol$a('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterate$2 = {exports: {}};

var wellKnownSymbol$9 = wellKnownSymbol$g;
var Iterators$1 = iterators;

var ITERATOR$3 = wellKnownSymbol$9('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$3] === it);
};

var wellKnownSymbol$8 = wellKnownSymbol$g;

var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$7 = wellKnownSymbol$g;

var TO_STRING_TAG$1 = wellKnownSymbol$7('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var classof$4 = classof$5;
var Iterators = iterators;
var wellKnownSymbol$6 = wellKnownSymbol$g;

var ITERATOR$2 = wellKnownSymbol$6('iterator');

var getIteratorMethod$1 = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || Iterators[classof$4(it)];
};

var anObject$5 = anObject$b;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$5(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject$5(returnMethod.call(iterator));
    throw error;
  }
};

var anObject$4 = anObject$b;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var toLength = toLength$4;
var bind$2 = functionBindContext;
var getIteratorMethod = getIteratorMethod$1;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate$1 = iterate$2.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind$2(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject$4(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate$1.stop = function (result) {
  return new Result(true, result);
};

var wellKnownSymbol$5 = wellKnownSymbol$g;

var ITERATOR$1 = wellKnownSymbol$5('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$1] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$1] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var anObject$3 = anObject$b;
var aFunction$2 = aFunction$4;
var wellKnownSymbol$4 = wellKnownSymbol$g;

var SPECIES$1 = wellKnownSymbol$4('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$3(O).constructor;
  var S;
  return C === undefined || (S = anObject$3(C)[SPECIES$1]) == undefined ? defaultConstructor : aFunction$2(S);
};

var getBuiltIn$1 = getBuiltIn$5;

var engineUserAgent = getBuiltIn$1('navigator', 'userAgent') || '';

var userAgent$1 = engineUserAgent;

var engineIsIos = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent$1);

var global$6 = global$i;
var fails$2 = fails$b;
var classof$3 = classofRaw$1;
var bind$1 = functionBindContext;
var html = html$2;
var createElement = documentCreateElement$1;
var IS_IOS$1 = engineIsIos;

var location = global$6.location;
var set = global$6.setImmediate;
var clear = global$6.clearImmediate;
var process$3 = global$6.process;
var MessageChannel = global$6.MessageChannel;
var Dispatch = global$6.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$6.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof$3(process$3) == 'process') {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$1(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$6.addEventListener &&
    typeof postMessage == 'function' &&
    !global$6.importScripts &&
    !fails$2(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global$6.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$5 = global$i;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var classof$2 = classofRaw$1;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var process$2 = global$5.process;
var Promise$1 = global$5.Promise;
var IS_NODE$1 = classof$2(process$2) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$5, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE$1) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;
    notify$1 = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$1 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global$5, flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aFunction$1 = aFunction$4;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1(resolve);
  this.reject = aFunction$1(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$2 = anObject$b;
var isObject$2 = isObject$9;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$2(C);
  if (isObject$2(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$4 = global$i;

var hostReportErrors$1 = function (a, b) {
  var console = global$4.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$3 = global$i;
var userAgent = engineUserAgent;

var process$1 = global$3.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var $$2 = _export;
var global$2 = global$i;
var getBuiltIn = getBuiltIn$5;
var NativePromise = nativePromiseConstructor;
var redefine$1 = redefine$5.exports;
var redefineAll = redefineAll$1;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var isObject$1 = isObject$9;
var aFunction = aFunction$4;
var anInstance = anInstance$1;
var classof$1 = classofRaw$1;
var inspectSource = inspectSource$3;
var iterate = iterate$2.exports;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule = internalState;
var isForced = isForced_1;
var wellKnownSymbol$3 = wellKnownSymbol$g;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol$3('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof$1(process) == 'process';
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$1(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global$2['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global$2, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global$2, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine$1(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $$2({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global$2, arguments));
      }
    });
  }
}

$$2({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$$2({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$$2({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$2({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var anObject$1 = anObject$b;

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$1 = fails$b;

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

regexpStickyHelpers.UNSUPPORTED_Y = fails$1(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$1(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

var $$1 = _export;
var exec = regexpExec;

$$1({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var redefine = redefine$5.exports;
var anObject = anObject$b;
var fails = fails$b;
var flags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var isObject = isObject$9;
var classof = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$g;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

var isRegExp = isRegexp;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$g;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

var $ = _export;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$3;
var correctIsRegExpLogic = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var global$1 = global$i;
var DOMIterables = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$7;
var wellKnownSymbol = wellKnownSymbol$g;

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var icon = `data:image/png;base64,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`;

const ETHEREUM_ACCOUNT_ABI = parseAbi(["function functionCall(string receiver_id, string method_name, bytes args, uint64 gas, uint32 yoctoNear) payable", "function transfer(string receiver_id, uint32 yoctoNear) payable", "function addKey(uint8 public_key_kind, bytes public_key, uint64 nonce, bool is_full_access, bool is_limited_allowance, uint128 allowance, string receiver_id, string[] method_names) external", "function deleteKey(uint8 public_key_kind, bytes public_key) external"]);
const DEFAULT_ACCESS_KEY_ALLOWANCE = "250000000000000000000000"; // 0.25 NEAR
const RLP_EXECUTE = "rlp_execute";
const MAX_TGAS = BigInt(270e12); // Handle overhead of rlp_execute to validate the Ethereum transaction.
class EthTxError extends Error {}

const modalStyles = `
  .ethereum-wallet-modal *,
  .ethereum-wallet-modal *::before,
  .ethereum-wallet-modal *::after {
    box-sizing: border-box;
  }
  .ethereum-wallet-modal button {
    cursor: pointer;
    top: auto;
  }
  .ethereum-wallet-modal button:hover {
    top: auto;
  }
  .ethereum-wallet-modal button:focus-visible {
    top: auto;
  }

  .ethereum-wallet-modal dt {
    flex-shrink: 0;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: #202020;
    font-weight: 500;
  }
  .ethereum-wallet-modal dd {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: #202020;
    font-weight: 700;
    text-align: right;
    word-break: break-all;
    overflow-wrap: break-word;
  }

  .ethereum-wallet-modal {
    display: none;
    position: relative;
    z-index: 9999;
  }
  .ethereum-wallet-modal-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .ethereum-wallet-modal-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    overflow-y: auto;
  }
  .ethereum-wallet-modal-container {
    display: flex;
    min-height: 100%;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    text-align: center;
  }
  .ethereum-wallet-modal-content {
    position: relative;
    overflow: hidden;
    border-radius: 1rem;
    background-color: #fff;
    padding: 20px;
    text-align: left;
    max-width: 400px;
    width: 100%;
    box-shadow:
      0px 4px 8px rgba(0, 0, 0, 0.06),
      0px 0px 0px 1px rgba(0, 0, 0, 0.06);
  }

  .ethereum-wallet-modal h2 {
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    letter-spacing: -0.1px;
    color: #202020;
    margin: 0;
  }

  .ethereum-wallet-txs {
    margin: 20px 0 10px 0;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }

  .ethereum-wallet-tx {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .ethereum-wallet-tx:not(.ethereum-wallet-tx-single) {
    padding: 0 10px;
  }
  .ethereum-wallet-tx-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 10px;
    width: 100%;
  }
  .ethereum-wallet-tx-list-header p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: #202020;
    font-weight: 700;
  }
  .ethereum-wallet-tx-list-header svg {
    height: 24px;
    width: 24px;
  }

  .ethereum-wallet-tx-explorer-link {
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }
  .ethereum-wallet-tx-explorer-link:hover {
    background-color: #DDF3E4;
  }
  .ethereum-wallet-tx-explorer-link svg {
    height: 16px;
    width: 16px;
    color: #202020;
  }

  .ethereum-wallet-tx.ethereum-wallet-tx-signing {
    background-color: #F9F9F9;
    padding-bottom: 10px;
    border-radius: 8px;
  }
  .ethereum-wallet-tx.ethereum-wallet-tx-pending {
    background-color: #F9F9F9;
    border-radius: 8px;
  }
  .ethereum-wallet-tx.ethereum-wallet-tx-completed {
    background-color: #F2FCF5;
    border-radius: 8px;
  }

  .ethereum-wallet-tx-single .ethereum-wallet-tx-info-container {
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
  }
  .ethereum-wallet-tx-info-text > p {
    color: #646464;
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.04px;
  }
  .ethereum-wallet-tx-info-text > p:not(:last-child) {
    margin-bottom: 8px;
  }

  .ethereum-wallet-tx-info-row {
    padding: 14px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 20px;
  }
  .ethereum-wallet-tx-info-col {
    padding: 14px 10px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    row-gap: 4px;
    align-items: start;
  }
  .ethereum-wallet-tx-info-text {
    padding: 10px;
  }
  .ethereum-wallet-tx-params,
  .ethereum-wallet-tx-params dl {
    margin: 0;
  }
  .ethereum-wallet-tx .ethereum-wallet-tx-params {
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
  }
  .ethereum-wallet-tx-params div:not(:last-child) {
    border-bottom: 1px solid #EBEBEB;
  }

  .ethereum-wallet-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: #1C2024;
    border: 1px solid rgba(1, 6, 47, 0.173) !important;
    background-color: #fff !important;
    padding: 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
  }
  .ethereum-wallet-btn:hover {
    border: 1px solid rgba(1, 6, 47, 0.173);
    background-color: #F2F2F5 !important;
  }
  .ethereum-wallet-btn:focus-visible {
    outline: 2px solid;
    outline-offset: 2px;
    outline-color: #8B8D98;
    border: 1px solid rgba(1, 6, 47, 0.173);
  }
  .ethereum-wallet-btn-sm {
    padding: 10px 14px;
    font-size: 12px;
    line-height: 16px;
  }
  .ethereum-wallet-btn-xs {
    padding: 8px 12px;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.04px;
    border-radius: 9999px;
  }
  .ethereum-wallet-btn-confirm {
    width: 100%;
    margin-top: 24px;
  }
  .ethereum-wallet-btn-cancel {
    width: 100%;
    background-color: #FFF9F9 !important;
    color: #dc2626 !important;
    border: 1px solid #fecaca !important;
  }
  .ethereum-wallet-btn-cancel:hover {
    background-color: #fef2f2 !important;
  }
  .ethereum-wallet-btn-details {
    margin-top: 20px;
    border-radius: 9999px;
  }

  .ethereum-wallet-tx-error {
    font-size: 14px;
    line-height: 20px;
    color: #dc2626;
    font-weight: 700;
    text-align: center;
    text-wrap: balance;
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .ethereum-wallet-txs-details {
    display: none;
    margin-top: 10px;
    padding: 10px;
    background: #F1F1F1;
    border-radius: 8px;
    width: 100%;
    max-width: 100%;
    overflow: auto;
  }
  .ethereum-wallet-txs-details p {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.04px;
    color: #646464;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    margin: 0;
  }

  .ethereum-wallet-txs-status {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px;
    background: #F1F4FE;
    border-radius: 8px;
    width: 100%;
    margin-top: 24px;
    border: 1px solid rgba(0,0,0,0);
  }
  .ethereum-wallet-txs-status p {
    margin: 0;
    color: #384EAC;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  }

  .ethereum-wallet-tx-highlight {
    position: relative;
    z-index: 1;
  }
  .ethereum-wallet-tx-highlight::before {
    content: "";
    position: absolute;
    top: -4px;
    left: -6px;
    right: -6px;
    bottom: -4px;
    z-index: -1;
    background-color: #DDF3E4;
    border-radius: 8px;
  }

  .ethereum-wallet-spinner {
    position: absolute;
    right: 14px;
    top: 16px;
    width: 16px;
    height: 16px;
    border: 2px solid #384EAC;
    border-bottom-color: transparent;
    border-radius: 50%;
    animation: rotation 1s linear infinite;
  }
  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
`;

function createTxModal({
  onCancel,
  txs,
  relayerPublicKey,
  explorerUrl
}) {
  var _a;
  // Create a style element and append the CSS styles
  const styleElement = window.document.createElement("style");
  styleElement.textContent = modalStyles;
  window.document.head.appendChild(styleElement);
  // Container with display none/block
  const modalContainer = window.document.createElement("div");
  modalContainer.classList.add("ethereum-wallet-modal");
  modalContainer.setAttribute("aria-labelledby", "modal-title");
  modalContainer.setAttribute("role", "dialog");
  modalContainer.setAttribute("aria-modal", "true");
  // Backdrop
  const backdrop = window.document.createElement("div");
  backdrop.classList.add("ethereum-wallet-modal-backdrop");
  // Wrapper for modal
  const modalWrapper = window.document.createElement("div");
  modalWrapper.classList.add("ethereum-wallet-modal-wrapper");
  // Modal content container
  const modalContentContainer = window.document.createElement("div");
  modalContentContainer.classList.add("ethereum-wallet-modal-container");
  // Modal content
  const isLogIn = txs.find(tx => tx.actions[0].type === "AddKey");
  const isOnboard = txs.find(tx => tx.actions[0].type === "AddKey" && tx.actions[0].params.publicKey === relayerPublicKey);
  const modalContent = window.document.createElement("div");
  modalContent.classList.add("ethereum-wallet-modal-content");
  modalContent.innerHTML = `
    ${txs.length === 1 && isLogIn ? `<h2>${isOnboard ? "Onboard" : "Log in"}</h2>` : txs.length === 1 && txs[0].actions.length === 1 && txs[0].actions[0].type === "DeleteKey" ? "<h2>Log out</h2>" : isLogIn ? `<h2>Log in: send ${txs.length} transaction${txs.length > 1 ? "s" : ""}</h2>` : `<h2>Send ${txs.length} transaction${txs.length > 1 ? "s" : ""}</h2>`}
    <div class="ethereum-wallet-txs"></div>
    <button class="ethereum-wallet-btn ethereum-wallet-btn-sm ethereum-wallet-btn-cancel">Cancel</button>
  `;
  // // Append the elements to form the complete structure
  modalContentContainer.appendChild(modalContent);
  modalWrapper.appendChild(modalContentContainer);
  modalContainer.appendChild(backdrop);
  modalContainer.appendChild(modalWrapper);
  // Append modal container to document body
  window.document.body.appendChild(modalContainer);
  // Function to show the modal
  const showModal = () => {
    modalContainer.style.display = "block";
  };
  // Function to hide the modal
  const hideModal = () => {
    // modalContainer.style.display = "none";
    modalContainer.remove();
  };
  // On cancel button click
  (_a = window.document.querySelector(".ethereum-wallet-btn-cancel")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", () => {
    onCancel();
    hideModal();
  });
  const renderTxs = ({
    selectedIndex,
    ethTxHashes,
    error,
    showDetails,
    onShowDetails,
    onConfirm
  }) => {
    var _a;
    const container = document.querySelector(".ethereum-wallet-txs");
    container.innerHTML = "";
    txs.forEach((tx, i) => {
      var _a, _b;
      const txNumber = i + 1;
      const singleTx = txs.length === 1;
      const txElement = document.createElement("div");
      txElement.classList.add("ethereum-wallet-tx");
      if (singleTx) {
        txElement.classList.add("ethereum-wallet-tx-single");
      }
      const isCompleted = i < selectedIndex;
      const isActive = i === selectedIndex;
      const isPending = i > selectedIndex;
      const isSent = selectedIndex < ethTxHashes.length;
      const explorerLink = i < ethTxHashes.length ? `${explorerUrl}/tx/${ethTxHashes[i]}` : undefined;
      if (!singleTx) {
        if (isCompleted) {
          txElement.classList.add("ethereum-wallet-tx-completed");
        }
        if (isActive) {
          txElement.classList.add("ethereum-wallet-tx-signing");
        }
        if (isPending) {
          txElement.classList.add("ethereum-wallet-tx-pending");
        }
      }
      txElement.innerHTML = `
        ${isCompleted ? `
                <div class="ethereum-wallet-tx-list-header">
                  <div style="display: flex; align-items: center; column-gap: 8px;">
                    <p>Transaction ${txNumber}</p>
                    ${explorerLink ? `
                      <a href="${explorerLink}" target="_blank" rel="noopener noreferrer" aria-label="Open explorer link" class="ethereum-wallet-tx-explorer-link">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M6.22 8.72a.75.75 0 0 0 1.06 1.06l5.22-5.22v1.69a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0 0 1.5h1.69L6.22 8.72Z"/><path d="M3.5 6.75c0-.69.56-1.25 1.25-1.25H7A.75.75 0 0 0 7 4H4.75A2.75 2.75 0 0 0 2 6.75v4.5A2.75 2.75 0 0 0 4.75 14h4.5A2.75 2.75 0 0 0 12 11.25V9a.75.75 0 0 0-1.5 0v2.25c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-4.5Z"/></svg>
                      </a>
                        ` : ""}
                  </div>
                  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#fff" fill-opacity=".01" d="M0 0h24v24H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.403C6.148 1.403 1.403 6.147 1.403 12c0 5.852 4.745 10.596 10.597 10.596 5.852 0 10.596-4.744 10.596-10.596 0-5.853-4.744-10.597-10.596-10.597ZM2.923 12a9.077 9.077 0 1 1 18.153 0 9.077 9.077 0 0 1-18.153 0Zm13.331-3.14a.8.8 0 1 0-1.308-.92l-4.514 6.414L8.57 12.46a.8.8 0 0 0-1.142 1.121l2.534 2.58a.8.8 0 0 0 1.225-.1l5.066-7.2Z" fill="#30A46C"/></svg>
                </div>
              ` : isPending ? `
                <div class="ethereum-wallet-tx-list-header">
                  <p>Transaction ${txNumber}</p>
                  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#fff" fill-opacity=".01" d="M0 0h24v24H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.403 12C1.403 6.148 6.148 1.403 12 1.403c5.852 0 10.596 4.745 10.596 10.597 0 5.852-4.744 10.596-10.596 10.596S1.403 17.852 1.403 12ZM12 2.923a9.077 9.077 0 1 0 0 18.153 9.077 9.077 0 0 0 0-18.153Z" fill="#8D8D8D"/></svg>
                </div>
              ` : `
              ${!singleTx ? `
                <div class="ethereum-wallet-tx-list-header">
                  <p>Transaction ${txNumber}</p>
                  <svg class="ethereum-tx-circle" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#fff" fill-opacity=".01" d="M0 0h24v24H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.403 12C1.403 6.148 6.148 1.403 12 1.403c5.852 0 10.596 4.745 10.596 10.597 0 5.852-4.744 10.596-10.596 10.596S1.403 17.852 1.403 12ZM12 2.923a9.077 9.077 0 1 0 0 18.153 9.077 9.077 0 0 0 0-18.153Z" fill="#8D8D8D"/></svg>
                </div>
              ` : ""}
              <div class="ethereum-wallet-tx-params">
                ${tx.actions[0].type === "AddKey" ? tx.actions[0].params.accessKey.permission === "FullAccess" ? `
                        <div class="ethereum-wallet-tx-info-text">
                          <p>WARNING: The application is requesting a FullAccess key. You can lose your account and all your assets. Only approve this transaction if you know what you are doing!<p>
                        </div>` : tx.actions[0].params.accessKey.permission.allowance === "0" && tx.actions[0].params.publicKey === relayerPublicKey && tx.actions[0].params.accessKey.permission.receiverId === tx.signerId && ((_a = tx.actions[0].params.accessKey.permission.methodNames) === null || _a === void 0 ? void 0 : _a.length) === 1 && tx.actions[0].params.accessKey.permission.methodNames[0] === RLP_EXECUTE ? `
                        <div class="ethereum-wallet-tx-info-text">
                          <p>This one-time transaction will onboard your account and enable you to transact on NEAR Protocol.</p>
                        </div>` : `
                      <div class="ethereum-wallet-tx-info-text">
                        <p>Connect to ${tx.actions[0].params.accessKey.permission.receiverId}</p>
                        <p>
                          Network Fee Allowance: ${tx.actions[0].params.accessKey.permission.allowance === "0" ? "unlimited" : formatUnits(BigInt((_b = tx.actions[0].params.accessKey.permission.allowance) !== null && _b !== void 0 ? _b : DEFAULT_ACCESS_KEY_ALLOWANCE), 24)} NEAR
                        </p>
                        ${tx.actions[0].params.accessKey.permission.allowance === "0" ? "<p>WARNING: this key will have unlimited allowance spendable towards network fees, only approve this transaction if you trust the application and you know what you are doing!</p>" : "<p>This allowance is spendable by the application towards network fees incurred during use.</p>"}
                      </div>
                      ` : tx.actions[0].type === "DeleteKey" ? `
                      <div class="ethereum-wallet-tx-info-text">
                        <p>This is an optional transaction which removes the application access key. If you reject the transaction, the key will be reused when you login next time.</p>
                      </div>
                      ` : tx.actions[0].type === "FunctionCall" ? `
                    <dl>
                      <div class="ethereum-wallet-tx-info-row">
                        <dt>From</dt>
                        <dd>${tx.signerId}</dd>
                      </div>
                      <div class="ethereum-wallet-tx-info-row">
                        <dt>To</dt>
                        <dd>${tx.receiverId}</dd>
                      </div>
                      <div class="ethereum-wallet-tx-info-row">
                        <dt>Type</dt>
                        <dd class="ethereum-wallet-tx-highlight">${tx.actions[0].params.methodName}</dd>
                      </div>
                      ${tx.actions[0].params.deposit === "1" || tx.actions[0].params.deposit === "0" ? "" : `
                          <div class="ethereum-wallet-tx-info-row">
                            <dt>Deposit</dt>
                            <dd class="ethereum-wallet-tx-highlight">${formatUnits(BigInt(tx.actions[0].params.deposit), 24)} NEAR</dd>
                          </div>
                        `}
                    </dl>
                    ` : tx.actions[0].type === "Transfer" ? `
                      <dl>
                        <div class="ethereum-wallet-tx-info-row">
                          <dt>From</dt>
                          <dd>${tx.signerId}</dd>
                        </div>
                        <div class="ethereum-wallet-tx-info-row">
                          <dt>To</dt>
                          <dd>${tx.receiverId}</dd>
                        </div>
                        <div class="ethereum-wallet-tx-info-row">
                          <dt>Type</dt>
                          <dd class="ethereum-wallet-tx-highlight">${tx.actions[0].type}</dd>
                        </div>
                        <div class="ethereum-wallet-tx-info-row">
                          <dt>Amount</dt>
                          <dd class="ethereum-wallet-tx-highlight">${formatUnits(BigInt(tx.actions[0].params.deposit), 24)} NEAR</dd>
                        </div>
                      </dl>
                      ` : `
                      <div class="ethereum-wallet-tx-info-text">
                        <p>Unknown transaction type.</p>
                      </div>
                    `}
              </div>
              <button class="ethereum-wallet-btn ethereum-wallet-btn-xs ethereum-wallet-btn-details">Show details</button>
              <div class="ethereum-wallet-txs-details">
                <p>${JSON.stringify(tx.actions[0], null, 2)}</p>
              </div>
              ${error ? `<p class="ethereum-wallet-tx-error">${error}</p>` : ""}
              ${onConfirm ? `<button class="ethereum-wallet-btn ethereum-wallet-btn-confirm" id="confirm-btn-${i}">
                      Confirm transaction
                    </button>` : `<div class="ethereum-wallet-txs-status">
                      <p>
                      ${isSent ? "Sending transaction" : "Confirm in your wallet"}
                      </p>
                      <div class="ethereum-wallet-spinner"></div>
                    </div>`}
            `}
      `;
      container.appendChild(txElement);
    });
    if (onConfirm) {
      (_a = window.document.querySelector(`#confirm-btn-${selectedIndex}`)) === null || _a === void 0 ? void 0 : _a.addEventListener("click", () => {
        onConfirm();
      });
    }
    const toggleButton = window.document.querySelector(".ethereum-wallet-btn-details");
    const detailsContainer = window.document.querySelector(".ethereum-wallet-txs-details");
    if (detailsContainer && toggleButton) {
      if (showDetails) {
        detailsContainer.style.display = "block";
        toggleButton.textContent = "Hide details";
      } else {
        detailsContainer.style.display = "none";
        toggleButton.textContent = "Show details";
      }
    }
    toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.addEventListener("click", () => {
      if (!detailsContainer || !toggleButton) {
        return;
      }
      if (detailsContainer.style.display === "none" || detailsContainer.style.display === "") {
        detailsContainer.style.display = "block";
        toggleButton.textContent = "Hide details";
        if (onShowDetails) {
          onShowDetails(true);
        }
      } else {
        detailsContainer.style.display = "none";
        toggleButton.textContent = "Show details";
        if (onShowDetails) {
          onShowDetails(false);
        }
      }
    });
  };
  return {
    showModal,
    hideModal,
    renderTxs
  };
}
function createChainSwitchModal({
  chain
}) {
  var _a, _b;
  // Create a style element and append the CSS styles
  const styleElement = window.document.createElement("style");
  styleElement.textContent = modalStyles;
  window.document.head.appendChild(styleElement);
  // Container with display none/block
  const modalContainer = window.document.createElement("div");
  modalContainer.classList.add("ethereum-wallet-modal");
  modalContainer.setAttribute("aria-labelledby", "modal-title");
  modalContainer.setAttribute("role", "dialog");
  modalContainer.setAttribute("aria-modal", "true");
  // Backdrop
  const backdrop = window.document.createElement("div");
  backdrop.classList.add("ethereum-wallet-modal-backdrop");
  // Wrapper for modal
  const modalWrapper = window.document.createElement("div");
  modalWrapper.classList.add("ethereum-wallet-modal-wrapper");
  // Modal content container
  const modalContentContainer = window.document.createElement("div");
  modalContentContainer.classList.add("ethereum-wallet-modal-container");
  // Modal content
  const modalContent = window.document.createElement("div");
  modalContent.classList.add("ethereum-wallet-modal-content");
  modalContent.innerHTML = `
    <h2>Switch Network</h2>
    <div class="ethereum-wallet-tx-params">
      <div class="ethereum-wallet-tx-info-text">
        <p>Please approve the switch network request in your wallet.</p>
        <p>If you experience problems connecting you may need to add the network manually from your wallet settings and try again.</p>
      </div>
      <dl>
        <div class="ethereum-wallet-tx-info-col">
          <dt>Network Name</dt>
          <dd>${chain.name}</dd>
        </div>
        <div class="ethereum-wallet-tx-info-col">
          <dt>RPC URL</dt>
          <dd>${chain.rpcUrls.default.http[0]}</dd>
        </div>
        <div class="ethereum-wallet-tx-info-col">
          <dt>Chain ID</dt>
          <dd>${chain.id}</dd>
        </div>
        <div class="ethereum-wallet-tx-info-col">
          <dt>Symbol</dt>
          <dd>${chain.nativeCurrency.symbol}</dd>
        </div>
        <div class="ethereum-wallet-tx-info-col">
          <dt>Block Explorer URL</dt>
          <dd>${(_a = chain.blockExplorers) === null || _a === void 0 ? void 0 : _a.default.url}</dd>
        </div>
      </dl>
    </div>
    <button class="ethereum-wallet-btn ethereum-wallet-btn-sm ethereum-wallet-btn-cancel">Close</button>
  `;
  // // Append the elements to form the complete structure
  modalContentContainer.appendChild(modalContent);
  modalWrapper.appendChild(modalContentContainer);
  modalContainer.appendChild(backdrop);
  modalContainer.appendChild(modalWrapper);
  // Append modal container to document body
  window.document.body.appendChild(modalContainer);
  // Function to show the modal
  const showModal = () => {
    modalContainer.style.display = "block";
  };
  // Function to hide the modal
  const hideModal = () => {
    // modalContainer.style.display = "none";
    modalContainer.remove();
  };
  // On cancel button click
  (_b = window.document.querySelector(".ethereum-wallet-btn-cancel")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", () => {
    hideModal();
  });
  return {
    showModal,
    hideModal
  };
}

let wagmiCore = null;
const importWagmiCore = () => __awaiter(void 0, void 0, void 0, function* () {
  // Commonjs support NA with @wagmi/core:
  // https://wagmi.sh/core/guides/migrate-from-v1-to-v2#dropped-commonjs-support
  return import('@wagmi/core').then(module => {
    wagmiCore = module;
  });
});
const setupEthereumWalletsState = id => __awaiter(void 0, void 0, void 0, function* () {
  const keystore = new nearAPI.keyStores.BrowserLocalStorageKeyStore(window.localStorage, `near-wallet-selector:${id}:keystore:`);
  return {
    keystore,
    subscriptions: [],
    isConnecting: false
  };
});
const EthereumWallets = ({
  id,
  options,
  store,
  provider,
  emitter,
  logger,
  params: {
    wagmiConfig,
    web3Modal,
    chainId,
    alwaysOnboardDuringSignIn: _alwaysOnboardDuringSignIn = false,
    devMode,
    devModeAccount: _devModeAccount = "eth-wallet.testnet",
    nearNodeUrl,
    skipSignInAccessKey
  }
}) => __awaiter(void 0, void 0, void 0, function* () {
  var _a, _b;
  if (!wagmiCore) {
    throw new Error("@wagmi/core not imported.");
  }
  const _state = yield setupEthereumWalletsState(id);
  const expectedChainId = chainId !== null && chainId !== void 0 ? chainId : options.network.networkId === "mainnet" ? 397 : 398;
  const chain = wagmiConfig.chains.find(c => c.id === expectedChainId);
  if (!chain) {
    throw new Error("Failed to parse NEAR chain from wagmiConfig.");
  }
  const nearRpc = chain.rpcUrls.default.http[0];
  if (!nearRpc) {
    throw new Error("Failed to parse NEAR rpc url from wagmiConfig.");
  }
  const nearExplorer = (_a = chain.blockExplorers) === null || _a === void 0 ? void 0 : _a.default.url;
  if (!nearExplorer) {
    throw new Error("Failed to parse NEAR explorer url from wagmiConfig.");
  }
  // NOTE: use a custom provider because the failover provider doesn't give error details.
  const nearProvider = new JsonRpcProvider((_b = nearNodeUrl !== null && nearNodeUrl !== void 0 ? nearNodeUrl :
  // @ts-expect-error
  provider.provider.connection) !== null && _b !== void 0 ? _b :
  // @ts-expect-error
  provider.provider.providers[
  // @ts-expect-error
  provider.provider.currentProviderIndex].connection);
  const getAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
    var _c;
    const address = (_c = wagmiCore.getAccount(wagmiConfig).address) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    const account = devMode ? address + "." + _devModeAccount : address;
    if (!account || !address) {
      return [];
    }
    const keyPair = yield _state.keystore.getKey(options.network.networkId, account);
    const accountLogIn = {
      accountId: account,
      publicKey: keyPair ? keyPair.getPublicKey().toString() : undefined
    };
    return [accountLogIn];
  });
  const cleanup = () => __awaiter(void 0, void 0, void 0, function* () {
    _state.subscriptions.forEach(subscription => subscription.remove());
    _state.subscriptions = [];
  });
  const executeTransaction = ({
    tx,
    relayerPublicKey
  }) => __awaiter(void 0, void 0, void 0, function* () {
    var _d, _e, _f, _g;
    //  Metamask has a check (https://github.com/MetaMask/core/blob/v360.0.0/packages/transaction-controller/src/utils/validation.ts#L100-L110) that
    //  prevents the execution of 'external' transactions (i.e., those originating outside MetaMask) when these transactions have an 'internal'
    //  account address in the to field (i.e., a user's own address within MetaMask) and contain non-empty data.
    //  When issuing an onboarding transaction, we set the to field to the user's own address and utilize the data field to pass required parameters to the Wallet Contract,
    //  specifically to add the provided public key to the account.
    //  We hash to value for AddKey/DeleteKey to bypass that metamask check. In the Wallet Contract itself contract compares to address with address hash.
    const to = /^0x([A-Fa-f0-9]{40})$/.test(tx.receiverId) && !["AddKey", "DeleteKey"].includes(tx.actions[0].type) ? tx.receiverId : "0x" + keccak256(toHex(tx.receiverId)).slice(26);
    let ethTx;
    switch (tx.actions[0].type) {
      case "AddKey":
        {
          const publicKey = bytesToHex(bs58.decode(tx.actions[0].params.publicKey.split(":")[1]));
          if (tx.actions[0].params.accessKey.permission === "FullAccess") {
            const args = [0, publicKey, BigInt((_d = tx.actions[0].params.accessKey.nonce) !== null && _d !== void 0 ? _d : 0), true, false, BigInt(0), "", [] // Not used with is_full_access
            ];
            ethTx = {
              abi: ETHEREUM_ACCOUNT_ABI,
              address: to,
              functionName: "addKey",
              args,
              chainId: expectedChainId,
              type: "legacy"
            };
            throw new Error("Requesting a FullAccess key is not allowed.");
          } else {
            const allowance = BigInt((_e = tx.actions[0].params.accessKey.permission.allowance) !== null && _e !== void 0 ? _e : DEFAULT_ACCESS_KEY_ALLOWANCE);
            const args = [0, publicKey, BigInt((_f = tx.actions[0].params.accessKey.nonce) !== null && _f !== void 0 ? _f : 0), false, allowance > 0 ? true : false, allowance, tx.actions[0].params.accessKey.permission.receiverId, (_g = tx.actions[0].params.accessKey.permission.methodNames) !== null && _g !== void 0 ? _g : []];
            ethTx = {
              abi: ETHEREUM_ACCOUNT_ABI,
              address: to,
              functionName: "addKey",
              args,
              gasPrice: tx.actions[0].params.publicKey === relayerPublicKey && tx.receiverId === tx.actions[0].params.accessKey.permission.receiverId ?
              // Free onboarding tx: fix 1 wei gasPrice because some wallets ignore 0 gasPrice.
              // Rpc will also return a dust eth_getBalance for accounts not yet onboarded to trick wallets
              // into accepting this free transaction even before the user owns NEAR.
              BigInt(1) : undefined,
              chainId: expectedChainId,
              type: "legacy"
            };
          }
          break;
        }
      case "DeleteKey":
        {
          const publicKey = bytesToHex(bs58.decode(tx.actions[0].params.publicKey.split(":")[1]));
          const args = [0, publicKey];
          ethTx = {
            abi: ETHEREUM_ACCOUNT_ABI,
            address: to,
            functionName: "deleteKey",
            args,
            chainId: expectedChainId,
            type: "legacy"
          };
          break;
        }
      case "FunctionCall":
        {
          const yoctoNear = BigInt(tx.actions[0].params.deposit) % BigInt(1e6);
          const value = BigInt(tx.actions[0].params.deposit) / BigInt(1e6);
          const requestedGas = BigInt(tx.actions[0].params.gas);
          const nearGas = requestedGas <= MAX_TGAS ? requestedGas : MAX_TGAS;
          const args = [tx.receiverId, tx.actions[0].params.methodName, bytesToHex(stringifyJsonOrBytes(tx.actions[0].params.args)), nearGas, +yoctoNear.toString()];
          ethTx = {
            abi: ETHEREUM_ACCOUNT_ABI,
            address: to,
            functionName: "functionCall",
            args,
            value,
            chainId: expectedChainId,
            type: "legacy"
          };
          break;
        }
      case "Transfer":
        {
          const yoctoNear = BigInt(tx.actions[0].params.deposit) % BigInt(1e6);
          const value = BigInt(tx.actions[0].params.deposit) / BigInt(1e6);
          const args = [tx.receiverId, +yoctoNear.toString()];
          ethTx = {
            abi: ETHEREUM_ACCOUNT_ABI,
            address: to,
            functionName: "transfer",
            args,
            value,
            chainId: expectedChainId,
            type: "legacy"
          };
          break;
        }
      default:
        {
          throw new Error("Invalid action type");
        }
    }
    // NOTE: re-add simulateContract and parse errors after eth_call implements errors.
    // const { request } = await wagmiCore!.simulateContract(wagmiConfig, ethTx);
    const result = yield wagmiCore.writeContract(wagmiConfig, ethTx);
    return result;
  });
  // Watch Ethereum wallet changes.
  const setupEvents = () => __awaiter(void 0, void 0, void 0, function* () {
    const unwatchAccount = wagmiCore.watchAccount(wagmiConfig, {
      onChange: data => __awaiter(void 0, void 0, void 0, function* () {
        var _h;
        // Ethereum wallet disconnected: also disconnect NEAR account.
        if (!data.address && data.status === "disconnected") {
          emitter.emit("signedOut", null);
          return;
        }
        // Ethereum wallet switched connected account: also switch NEAR account if already signed in or disconnect.
        if (data.address && data.status === "connected") {
          if ((_h = store.getState().contract) === null || _h === void 0 ? void 0 : _h.contractId) {
            const address = data.address.toLowerCase();
            const keyPair = yield _state.keystore.getKey(options.network.networkId, devMode ? address + "." + _devModeAccount : address);
            if (!keyPair && !skipSignInAccessKey) {
              try {
                wagmiCore.disconnect(wagmiConfig);
              } catch (error) {
                logger.error(error);
              }
              emitter.emit("signedOut", null);
              return;
            }
          }
          emitter.emit("accountsChanged", {
            accounts: yield getAccounts()
          });
        }
      })
    });
    _state.subscriptions.push({
      remove: () => unwatchAccount()
    });
  });
  setupEvents();
  // Add signerId and receiverId defaults.
  const transformTransactions = transactions => __awaiter(void 0, void 0, void 0, function* () {
    const state = store.getState();
    const {
      contract
    } = state;
    const [accountLogIn] = yield getAccounts();
    if (!accountLogIn) {
      throw new Error("No active account");
    }
    return transactions.map(transaction => {
      if (!contract && !transaction.receiverId) {
        throw new Error(`Missing receiverId, got '${transaction.receiverId}'`);
      }
      return Object.assign(Object.assign({}, transaction), {
        signerId: transaction.signerId || accountLogIn.accountId,
        receiverId: transaction.receiverId || contract.contractId
      });
    });
  });
  // Separate actions into individual transactions because not available in 0x accounts.
  const transformEthereumTransactions = transactions => {
    return transactions.map(transaction => {
      return transaction.actions.map(action => {
        return {
          signerId: transaction.signerId,
          receiverId: transaction.receiverId,
          actions: [action]
        };
      });
    }).flat();
  };
  // Check if accessKey is usable to execute all transaction.
  const validateAccessKey = ({
    transactions,
    accessKey
  }) => {
    if (accessKey.permission === "FullAccess") {
      return true;
    }
    return transactions.every(tx => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const {
        receiver_id,
        method_names
      } = accessKey.permission.FunctionCall;
      if (receiver_id !== tx.receiverId) {
        return false;
      }
      return tx.actions.every(action => {
        if (action.type !== "FunctionCall") {
          return false;
        }
        const {
          methodName,
          deposit
        } = action.params;
        if (method_names.length && !method_names.includes(methodName)) {
          return false;
        }
        return BigInt(deposit) <= 0;
      });
    });
  };
  // Get the relayer public key and onboarding transaction if needed.
  const getRelayerOnboardingInfo = ({
    accountId
  }) => __awaiter(void 0, void 0, void 0, function* () {
    var _j, _k, _l, _m;
    let relayerPublicKey;
    try {
      const response = yield fetch(nearRpc, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          jsonrpc: "2.0",
          id: 3,
          method: "near_getPublicKey"
        })
      });
      const {
        result
      } = yield response.json();
      relayerPublicKey = "ed25519:" + bs58.encode(Buffer.from(result.public_key, "hex"));
    } catch (error) {
      logger.error(error);
      throw new Error("Failed to fetch the relayer's public key.");
    }
    try {
      const key = yield nearProvider.query({
        request_type: "view_access_key",
        finality: "final",
        account_id: accountId,
        public_key: relayerPublicKey
      });
      logger.log("User account ready, relayer access key onboarded.", relayerPublicKey, key);
      return {
        relayerPublicKey,
        onboardingTransaction: null
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      logger.error(error);
      if (!((_j = error.message) === null || _j === void 0 ? void 0 : _j.includes("does not exist while viewing")) && !((_k = error.message) === null || _k === void 0 ? void 0 : _k.includes("doesn't exist")) && !((_l = error.message) === null || _l === void 0 ? void 0 : _l.includes("does not exist")) && !((_m = error.message) === null || _m === void 0 ? void 0 : _m.includes("has never been observed on the node"))) {
        throw new Error("Failed to view the relayer public key (view_access_key).");
      }
      logger.warn("Need to add the relayer access key:", relayerPublicKey);
      // Add the relayer's access key on-chain.
      return {
        relayerPublicKey,
        onboardingTransaction: {
          signerId: accountId,
          receiverId: accountId,
          actions: [{
            type: "AddKey",
            params: {
              publicKey: relayerPublicKey,
              accessKey: {
                nonce: 0,
                permission: {
                  receiverId: accountId,
                  allowance: "0",
                  methodNames: [RLP_EXECUTE]
                }
              }
            }
          }]
        }
      };
    }
  });
  const switchChain = () => __awaiter(void 0, void 0, void 0, function* () {
    const account = wagmiCore.getAccount(wagmiConfig);
    if (account.chainId !== expectedChainId) {
      const {
        showModal,
        hideModal
      } = createChainSwitchModal({
        chain
      });
      showModal();
      try {
        yield wagmiCore.switchChain(wagmiConfig, {
          chainId: expectedChainId
        });
      } catch (error) {
        logger.error(error);
        // TODO: add the link to onboarding page when available.
        throw new Error("Wallet didn't connect to NEAR Protocol network, try adding and selecting the network manually inside wallet settings.");
        // NOTE: we don't hide the modal in case of error to allow the user to add the network manually.
      }
      hideModal();
    }
  });
  const signAndSendTransactions = transactions => __awaiter(void 0, void 0, void 0, function* () {
    const nearTxs = yield transformTransactions(transactions);
    const [accountLogIn] = yield getAccounts();
    // If transactions can be executed with FunctionCall access key do it, otherwise execute 1 by 1 with Ethereum wallet.
    if (accountLogIn.publicKey && nearTxs.length) {
      let accessKeyUsable;
      try {
        const accessKey = yield nearProvider.query({
          request_type: "view_access_key",
          finality: "final",
          account_id: accountLogIn.accountId,
          public_key: accountLogIn.publicKey
        });
        accessKeyUsable = validateAccessKey({
          transactions: nearTxs,
          accessKey
        });
      } catch (error) {
        logger.error(error);
        accessKeyUsable = false;
      }
      if (accessKeyUsable) {
        const signer = new nearAPI.InMemorySigner(_state.keystore);
        const signedTransactions = yield signTransactions(nearTxs, signer, options.network);
        const _results = [];
        for (let i = 0; i < signedTransactions.length; i += 1) {
          const nearTx = yield nearProvider.sendTransaction(signedTransactions[i]);
          logger.log("NEAR transaction:", nearTx);
          if (typeof nearTx.status === "object" && typeof nearTx.status.Failure === "object" && nearTx.status.Failure !== null) {
            logger.error("Transaction execution error.");
            throw parseRpcError(nearTx.status.Failure);
          }
          _results.push(nearTx);
        }
        return _results;
      }
    }
    const {
      relayerPublicKey,
      onboardingTransaction
    } = yield getRelayerOnboardingInfo({
      accountId: accountLogIn.accountId
    });
    let txs = transformEthereumTransactions(nearTxs);
    if (onboardingTransaction) {
      // Onboard the relayer before executing other transactions.
      txs = [onboardingTransaction, ...txs];
    }
    yield switchChain();
    const results = [];
    yield (() => {
      return new Promise((resolve, reject) => {
        const {
          showModal,
          hideModal,
          renderTxs
        } = createTxModal({
          onCancel: () => {
            reject("User canceled Ethereum wallet transaction(s).");
          },
          txs,
          relayerPublicKey,
          explorerUrl: nearExplorer
        });
        showModal();
        (() => __awaiter(void 0, void 0, void 0, function* () {
          try {
            const ethTxHashes = [];
            for (const [index, tx] of txs.entries()) {
              let txHash;
              let txError = null;
              let showDetails = false;
              while (!txHash) {
                try {
                  yield (() => {
                    return new Promise((resolveTx, rejectTx) => {
                      renderTxs({
                        selectedIndex: index,
                        ethTxHashes,
                        error: txError,
                        showDetails,
                        onShowDetails: state => {
                          showDetails = state;
                        },
                        onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                          var _a, _b;
                          try {
                            txError = null;
                            renderTxs({
                              selectedIndex: index,
                              ethTxHashes,
                              error: txError,
                              showDetails
                            });
                            txHash = yield executeTransaction({
                              tx,
                              relayerPublicKey
                            });
                            resolveTx();
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          } catch (err) {
                            logger.error(err);
                            if (!((_a = err.message) === null || _a === void 0 ? void 0 : _a.includes("reject")) && !((_b = err.message) === null || _b === void 0 ? void 0 : _b.includes("denied"))) {
                              txError = "Transaction execution error.";
                            }
                            rejectTx(new EthTxError("Transaction request error."));
                          }
                        })
                      });
                    });
                  })();
                } catch (error) {
                  logger.error(error);
                  if (!(error instanceof EthTxError)) {
                    throw new Error("Ethereum modal render error.");
                  }
                }
              }
              logger.log(`Sent transaction: ${txHash}`);
              ethTxHashes.push(txHash);
              renderTxs({
                selectedIndex: index,
                ethTxHashes
              });
              yield new Promise(r => setTimeout(r, 2000));
              let receipt;
              try {
                // NOTE: error is thrown if tx failed so we catch it to get the receipt.
                receipt = yield wagmiCore.waitForTransactionReceipt(wagmiConfig, {
                  hash: txHash,
                  chainId: expectedChainId
                });
              } catch (error) {
                logger.error(error);
                while (!receipt) {
                  try {
                    yield new Promise(r => setTimeout(r, 1000));
                    receipt = yield wagmiCore.getTransactionReceipt(wagmiConfig, {
                      hash: txHash,
                      chainId: expectedChainId
                    });
                  } catch (err) {
                    logger.log(err);
                  }
                }
              }
              logger.log("Receipt:", receipt);
              let nearTx;
              while (!nearTx) {
                try {
                  yield new Promise(r => setTimeout(r, 1000));
                  nearTx = yield nearProvider.txStatus(
                  // @ts-expect-error
                  receipt.nearTransactionHash, accountLogIn.accountId);
                } catch (err) {
                  logger.log(err);
                }
              }
              logger.log("NEAR transaction:", nearTx);
              if (receipt.status !== "success") {
                const failedOutcome = nearTx.receipts_outcome.find(({
                  outcome
                }) => typeof outcome.status === "object" && typeof outcome.status.Failure === "object" && outcome.status.Failure !== null && outcome.executor_id === tx.receiverId);
                if (failedOutcome) {
                  reject(parseRpcError(failedOutcome.outcome.status.Failure));
                } else {
                  reject("Transaction execution error, failed to parse failure reason.");
                }
                // NOTE: after return, `finally { hideModal() }` will run.
                return;
              }
              results.push(nearTx);
            }
            resolve();
          } catch (error) {
            logger.error(error);
            reject(error);
          } finally {
            hideModal();
          }
        }))();
      });
    })();
    return results;
  });
  const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
    const [accountLogIn] = yield getAccounts();
    if (accountLogIn.publicKey) {
      try {
        // Check that the key exists before making a transaction.
        yield nearProvider.query({
          request_type: "view_access_key",
          finality: "final",
          account_id: accountLogIn.accountId,
          public_key: accountLogIn.publicKey
        });
        // If there is a connection problem with the wallet, the user can cancel from the modal to skip the disconnect transaction.
        // If not deleted, the access key will be reused during signIn.
        yield signAndSendTransactions([{
          signerId: accountLogIn.accountId,
          receiverId: accountLogIn.accountId,
          actions: [{
            type: "DeleteKey",
            params: {
              publicKey: accountLogIn.publicKey
            }
          }]
        }]);
        _state.keystore.removeKey(options.network.networkId, accountLogIn.accountId);
      } catch (error) {
        logger.error(error);
      }
    }
    try {
      wagmiCore.disconnect(wagmiConfig);
    } catch (error) {
      logger.error(error);
    }
    emitter.emit("signedOut", null);
    cleanup();
  });
  return {
    signIn({
      contractId,
      methodNames = []
    }) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("EthereumWallets:signIn", {
          contractId,
          methodNames
        });
        if (_state.isConnecting) {
          throw new Error("SignIn request already received.");
        }
        try {
          _state.isConnecting = true;
          let unwatchAccountConnected;
          let unsubscribeCloseModal;
          let account = wagmiCore.getAccount(wagmiConfig);
          let address = (_a = account.address) === null || _a === void 0 ? void 0 : _a.toLowerCase();
          // Open web3Modal and wait for a wallet to be connected or for the web3Modal to be closed.
          if (!address) {
            try {
              if (web3Modal) {
                web3Modal.open();
                yield (() => {
                  return new Promise((resolve, reject) => {
                    try {
                      unwatchAccountConnected = wagmiCore.watchAccount(wagmiConfig, {
                        onChange: data => {
                          if (!data.address) {
                            return;
                          }
                          resolve(data);
                        }
                      });
                      unsubscribeCloseModal = web3Modal.subscribeEvents(event => {
                        const newAccount = wagmiCore.getAccount(wagmiConfig);
                        if (event.data.event === "MODAL_CLOSE" && !newAccount.address) {
                          reject("Web3Modal closed without connecting to an Ethereum wallet.");
                        }
                      });
                    } catch (error) {
                      reject("User rejected");
                    }
                  });
                })();
              } else {
                yield wagmiCore.connect(wagmiConfig, {
                  connector: wagmiCore.injected()
                });
              }
              account = wagmiCore.getAccount(wagmiConfig);
              address = (_b = account.address) === null || _b === void 0 ? void 0 : _b.toLowerCase();
              if (!address) {
                throw new Error("Failed to get Ethereum wallet address");
              }
            } catch (error) {
              logger.error(error);
              throw new Error("Failed to connect Ethereum wallet.");
            } finally {
              try {
                // Prevent overshadowing the original exception
                if (unwatchAccountConnected) {
                  unwatchAccountConnected();
                }
                if (unsubscribeCloseModal) {
                  unsubscribeCloseModal();
                }
              } catch (error) {
                logger.error(error);
              }
            }
          } else {
            logger.log("Wallet already connected");
          }
          yield switchChain();
          // Login with FunctionCall access key, reuse keypair or create a new one.
          const accountId = devMode ? address + "." + _devModeAccount : address;
          let publicKey;
          if (contractId && !skipSignInAccessKey) {
            const keyPair = yield _state.keystore.getKey(options.network.networkId, accountId);
            let reUseKeyPair = false;
            if (keyPair) {
              try {
                yield nearProvider.query({
                  request_type: "view_access_key",
                  finality: "final",
                  account_id: accountId,
                  public_key: keyPair.getPublicKey().toString()
                });
                reUseKeyPair = true;
              } catch (error) {
                logger.warn("Local access key cannot be reused.");
                _state.keystore.removeKey(options.network.networkId, accountId);
              }
            }
            if (reUseKeyPair) {
              publicKey = keyPair.getPublicKey().toString();
              logger.log("Reusing existing publicKey:", publicKey);
            } else {
              const newAccessKeyPair = nearAPI.utils.KeyPair.fromRandom("ed25519");
              publicKey = newAccessKeyPair.getPublicKey().toString();
              logger.log("Created new publicKey:", publicKey);
              yield signAndSendTransactions([{
                signerId: accountId,
                receiverId: accountId,
                actions: [{
                  type: "AddKey",
                  params: {
                    publicKey,
                    accessKey: {
                      nonce: 0,
                      permission: {
                        receiverId: contractId,
                        allowance: DEFAULT_ACCESS_KEY_ALLOWANCE,
                        methodNames
                      }
                    }
                  }
                }]
              }]);
              yield _state.keystore.setKey(options.network.networkId, accountId, newAccessKeyPair);
            }
          } else if (_alwaysOnboardDuringSignIn) {
            // Check onboarding status and onboard the relayer if needed.
            yield signAndSendTransactions([]);
          }
          const accountLogIn = {
            accountId,
            publicKey
          };
          emitter.emit("signedIn", {
            contractId: contractId,
            methodNames: methodNames !== null && methodNames !== void 0 ? methodNames : [],
            accounts: [accountLogIn]
          });
          if (!_state.subscriptions.length) {
            setupEvents();
          }
          _state.isConnecting = false;
          try {
            // Hide modal which stays open after adding a new network.
            if (web3Modal) {
              web3Modal.close();
            }
          } catch (error) {
            logger.error(error);
          }
          return [accountLogIn];
        } catch (error) {
          _state.isConnecting = false;
          try {
            // Prevent overshadowing the original exception
            // Disconnect to let user start again from the beginning: wallet selection.
            wagmiCore.disconnect(wagmiConfig);
          } catch (err) {
            logger.error(err);
          }
          throw error;
        }
      });
    },
    signOut,
    getAccounts,
    verifyOwner({
      message
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("EthereumWallets:verifyOwner", {
          message
        });
        throw new Error("Not implemented: ed25519 N/A, '\x19Ethereum Signed Message:\n' prefix is not compatible, use personal_sign or eth_signTypedData_v4 instead.");
      });
    },
    signMessage({
      message,
      nonce,
      recipient
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("EthereumWallets:signMessage", {
          message,
          nonce,
          recipient
        });
        throw new Error("Not implemented: ed25519 N/A, '\x19Ethereum Signed Message:\n' prefix is not compatible, use personal_sign or eth_signTypedData_v4 instead.");
      });
    },
    signAndSendTransaction(transaction) {
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("EthereumWallets:signAndSendTransaction", transaction);
        const outcomes = yield signAndSendTransactions([transaction]);
        // Return the last transaction outcome.
        return outcomes[outcomes.length - 1];
      });
    },
    signAndSendTransactions({
      transactions
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("EthereumWallets:signAndSendTransactions", {
          transactions
        });
        return yield signAndSendTransactions(transactions);
      });
    }
  };
});
function setupEthereumWallets(params) {
  return () => __awaiter(this, void 0, void 0, function* () {
    var _a, _b;
    if (!wagmiCore) {
      if (params.wagmiCore) {
        wagmiCore = params.wagmiCore;
      } else {
        yield importWagmiCore();
      }
    }
    return {
      id: "ethereum-wallets",
      type: "injected",
      metadata: {
        name: "Ethereum Wallet",
        description: "Ethereum wallets (EOA) on NEAR Protocol.",
        iconUrl: (_a = params.iconUrl) !== null && _a !== void 0 ? _a : icon,
        deprecated: (_b = params.deprecated) !== null && _b !== void 0 ? _b : false,
        available: true,
        downloadUrl: "https://explorer.walletconnect.com"
      },
      init: config => {
        return EthereumWallets(Object.assign(Object.assign({}, config), {
          params
        }));
      }
    };
  });
}

export { setupEthereumWallets };
